import React from "react";
import "../styles/featuredprojthumbnail.css";
import { Link } from "react-router-dom";

const FeaturedProjThumbnail = ({ item, st }) => {
  return (
    <div className={`project-card featured ${st || ""}`}>
      <Link className="" key={item.id} to={`/Projects/${item.id}`}>
        <div className="feat-bg">
          <img src={item.img} alt={item.text} />
        </div>
        <div className="feat-overlay">
          <div className="feat-role">{item.role}</div>
          <div className="feat-title">{item.text}</div>
          <div className="feat-desc">{item.subtext}</div>
          <div className="feat-tags">
            {item.techstack.map((skill, i) => (
              <span key={i} className="tag">
                {skill}
              </span>
            ))}
          </div>
        </div>
      </Link>
    </div>
  );
};

export default FeaturedProjThumbnail;
